/**
 * Financial validations
 *
 * Validation schemas for financial information: income, occupation, etc.
 */
import { z } from "zod";
import { t, createValidator } from "./utils";
/**
 * Income validation schema factory
 */
export const incomeSchema = () => {
    return z
        .number()
        .min(1, { message: t("required") })
        .positive({ message: t("income.invalid") });
};
/**
 * Occupation validation schema factory
 */
export const occupationSchema = () => {
    return z.string().min(1, { message: t("required") });
};
// Validator functions
export const validateIncome = createValidator(incomeSchema);
export const validateOccupation = createValidator(occupationSchema);
